<template>
  <div class="userCartPage">
    <!-- <h1>Cart?</h1> -->
    <span v-if="itemsOnCart === 0 || !fetchedDeliveryFees">
      <h4>No Items on Cart Yet</h4>
    </span>
    <span v-else>
      <UserCart
        :itemsOnCart="itemsOnCart"
        :userCart="userCart"
        :cart-id="cartId"
        :user-logged-in="userLoggedIn"
        :deliveryFees="deliveryFees"
        :enableLoyaltyPoints="true"
        :user-loyalty-points="userData.points"
        :deliveryMessageBackground="deliveryMessageBackground"
        :deliveryMessageTextColor="deliveryMessageTextColor"
        @openSnackbar="$emit('openSnackbar', $event)"
        @removeOrder="$emit('removeOrder', $event)"
        @checkout="navigateToCheckout"
        @openSignInPage="$emit('openSignInPage', $event)"
        @refreshCart="$emit('refreshCart')"
        @cartItemChanged="$emit('cartItemChanged')"
      />
    </span>
  </div>
</template>

<script>
import { UserCart } from '@kiukicom/sidebar'
import httpClient from '@/services/httpClient'
import imgix from '@/services/imgix'

export default {
  name: 'UserCartPage',
  components: {
    UserCart
  },
  props: {
    deliveryMessageBackground: {
      required: false,
      type: String,
      default: '#3BAA5B'
    },
    deliveryMessageTextColor: {
      required: false,
      type: String,
      default: '#FFFFFF'
    }
  },
  computed: {
    userLoggedIn () {
      return this.$store.state.sidebar.userLoggedIn
    },
    currency () {
      return this.userCart.length
        ? this.userCart[0].currency !== undefined
          ? this.userCart[0].currency
          : 'GBP'
        : 'GBP'
    },
    userCartUpdated () {
      this.updateDeliveryFees()
      return this.$store.state.sidebar.userCartUpdated
    },
    isSingleSellerMarketPlace () {
      return process.env.VUE_APP_SINGLE_SELLER_MARKETPLACE === 'true'
    },
    cartId () {
      return this.$store.state.sidebar.cartId
    },
    userData () {
      return this.$store.state.sidebar.userData
    },
    userCart () {
      return this.$store.state.sidebar.userCart
    },
    itemsOnCart () {
      return this.userCart.reduce((acc, value) => {
        return acc + value.products.length
      }, 0)
    }
  },
  data () {
    return {
      mode: 'checkout',
      fetchedDeliveryFees: false,
      deliveryFees: [],
      imgix
    }
  },
  watch: {
    deliveryFees: {
      handler () {
      }
    },
    userCart: {
      handler () {
      },
      deep: true
    },
    userCartUpdated: {
      handler () {
        this.updateDeliveryFees()
      },
      deep: true
    }
  },
  mounted () {
    this.updateDeliveryFees()
  },
  methods: {
    navigateToCheckout () {
      this.$router.push('/checkout')
    },
    updateDeliveryFees (delay = 0) {
      setTimeout(() => {
        if (!this.userIsLogged && this.cartId !== null && !this.fetchedDeliveryFees) {
          httpClient
            .get(`/cart/${this.cartId}`)
            .then((response) => {
              this.deliveryFees = response.data.delivery_fees
              this.fetchedDeliveryFees = true
            }).catch((error) => {
              console.log(error)
            })
        } else if (this.cartId !== null) {
          httpClient
            .get('/cart/active')
            .then((response) => {
              this.deliveryFees = response.data.delivery_fees
              this.fetchedDeliveryFees = true
            }).catch((error) => {
              console.log(error)
            })
        } else {
          this.updateDeliveryFees(delay + 500)
        }
      }, 250 + delay)
    }
  },
  metaInfo () {
    return {
      title: 'Cart',
      meta: [ { name: 'robots', content: 'noindex' } ]
    }
  }
}
</script>

<style scoped lang="stylus">
.userCartPage {
  text-align: left;
  width: 100%;
  min-height: 90vh;
  max-width: 520px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 10px;
}
</style>
